/**
 * Cart page — quantity / remove + order note toggle
 */
(function () {
  var routes = window.routes || {
    cartChangeUrl: '/cart/change'
  };

  function changeCart(url) {
    return fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function () {
      window.location.reload();
    });
  }

  document.addEventListener('click', function (e) {
    var page = e.target.closest('[data-cart-page]');
    if (!page) return;

    var link = e.target.closest('a[data-action="update-item-quantity"], a[data-action="remove-item"]');
    if (!link) return;

    e.preventDefault();
    changeCart(link.href).catch(function () {
      window.location.href = link.href;
    });
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-page] .quantity-selector-current');
    if (!input) return;
    var lineId = input.getAttribute('data-line-id');
    var qty = parseInt(input.value, 10);
    if (!lineId || isNaN(qty) || qty < 0) return;
    var url = (routes.cartChangeUrl || '/cart/change') + '?quantity=' + qty + '&id=' + encodeURIComponent(lineId);
    changeCart(url).catch(function () {
      window.location.href = url;
    });
  });
})();
